import Head from '../../layouts/Head';
import DetailsContainer from '../../containers/Details';
import Footer from '../../layouts/Footer';

const Detailsx = () => {

  return (
    <>
		<Head Title='Details' />
		<DetailsContainer />
		<Footer />
    </>
  );
}

export default Detailsx;

